import { spacing } from "../spacingScale";

/**
 * Semantic spacing roles — intent-based presets built from the primitive scale.
 * No raw pixel literals; all values resolve through `spacing`.
 */
export const space = {
  inline: {
    xs: spacing[4],
    sm: spacing[8],
    md: spacing[12],
    lg: spacing[16],
    xl: spacing[24],
  },
  stack: {
    xs: spacing[4],
    sm: spacing[8],
    md: spacing[16],
    lg: spacing[24],
    xl: spacing[32],
  },
  inset: {
    xs: spacing[8],
    sm: spacing[12],
    md: spacing[16],
    lg: spacing[24],
    xl: spacing[32],
  },
  squish: {
    sm: { x: spacing[12], y: spacing[8] },
    md: { x: spacing[16], y: spacing[12] },
    lg: { x: spacing[24], y: spacing[16] },
  },
} as const;

export type TSpaceSemantic = typeof space;
